import React from 'react';
import { Link as LinkNav } from 'react-router';
import LinkUI from '@mui/material/Link';

import type { ILinkProps } from './Link.typings';

export const Link: React.FC<ILinkProps> = props => {
    const relProp = props.target === '_blank' && !props.rel ? 'noopener noreferrer' : props.rel;

    return (
        <LinkUI
            component={LinkNav}
            to={props.href}
            rel={relProp}
            {...props}
        >
            {props.children}
        </LinkUI>
    );
};
